export default {
  addOns: '附加項目',
  unavailable: '無法使用',
  person: '人',
  people: '人',
  reserveNow: '立即預約',
  selectTime: '選擇時間',
  select: '選擇',
  reserve: '預約',
  time: '時間',
  tier: '層級',
  questions: '問題',
  addToCart: '加入購物車',
  checkout: '結帳',
  total: '總計',
  availability: '可用性',
  whatsIncluded: '包含內容',
  showMore: '顯示更多',
  showLess: '顯示較少',
  session: '場次',
  viewDetails: '查看詳情',
  findAvailability: '查找可用時段',
  loading: '載入中',
  capacity: '容量',
  noAvailableSessionsOnThisDate: '此日期無可用場次',
  noGroupAvailableOnThisDateAndTime: '此日期與時間無可用的 {{groupTitle}}',
  noCollectionFound: '找不到集合！',
  noResourceGroupFound: '找不到資源群組！',
  noData: '無資料！',
  continue: '繼續',
};
